import { platformClient } from '../../platform/api/platform.client';
import type { LoginResponse } from '../../platform/types';

export interface LmsAuthenticateRequest {
  assertion_jwt: string;
}

export interface LmsMembership {
  membership_key: string;
  role: string;
  school_id: string;
}

export interface LmsUser {
  id: string;
  email: string;
  roles: string[];
  memberships?: LmsMembership[];
  profile?: {
    name?: string;
    avatar_url?: string | null;
  };
  last_active_membership_key?: string;
}

export interface LmsAuthenticateResponse {
  access_token: string;
  refresh_token?: string;
  token_type?: string;
  user: LmsUser;
}

export interface LmsApiErrorResponse {
  error?: {
    code?: string;
    message?: string;
    trace_id?: string;
  };
  detail?: string;
}

/**
 * Exchange LMS assertion JWT for TKM session via gateway (POST /auth/authenticate).
 * Uses platformClient → serviceUrls.gateway (never VITE_PLATFORM_SERVICE_URL).
 */
export async function authenticateLms(
  data: LmsAuthenticateRequest
): Promise<LmsAuthenticateResponse> {
  const response = await platformClient.post<LoginResponse>('/auth/authenticate', data, {
    headers: { 'x-skip-auth-redirect': '1' },
  });
  return response.data as LmsAuthenticateResponse;
}
